var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-header",
        { attrs: { height: "42px" } },
        [
          _c(
            "el-button-group",
            { staticClass: "ik-list-menu" },
            [
              _vm.pageData.mode === "edit" || _vm.pageData.mode === "details"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoCreateBtn },
                    },
                    [_vm._v("新增 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "details"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoUpdateBtn },
                    },
                    [_vm._v("修改 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "edit" || _vm.pageData.mode === "details"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoCopyBtn },
                    },
                    [_vm._v("复制 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "edit"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoDetailsBtn },
                    },
                    [_vm._v("详情 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "add" || _vm.pageData.mode === "edit"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoSaveBtn },
                    },
                    [_vm._v(" 保存 ")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "ik-list-menu-btn",
                  attrs: { size: "medium" },
                  on: { click: _vm.infoCancelBtn },
                },
                [_vm._v("取消 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-main", [_c("h-form", { ref: "form" }), _c("d-table")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }